
$(document).ready(function(){
   $(".accordion").click(function(){
     _this = $(this).find(".accordion__body");
     $('.accordion__body').not(_this).hide();
     $(this).find(".accordion__body").toggle();
     $('.accordion').not(this).addClass('accordion-span');
     $(this).toggleClass('accordion-span');
   });
  $('body').on('click','a.wishlist__cstm',function(e){
   e.preventDefault(); 
    localStorage.setItem("active_dashboard",'.cstm_wishlist');
     window.location.href='/account';
  });
  var url = window.location.href;
  if(url.includes('address')){
    window.location.href='/account';
  }
   $(".account__details").hide();
  if(localStorage.getItem("active_dashboard")){
   var class_attr_active  = localStorage.getItem("active_dashboard");
    var class_attr_activeli = class_attr_active.split('_')[1];
    var active__tab = 'li[account-attr="'+class_attr_activeli+'"]';
     $(class_attr_active).show();
    $(".cstm__account__sidebar li").removeClass('active');
    $(active__tab).addClass('active');
  }
  else{
   $('.cstm_dashboard').show(); 
  }
  
  $(".cstm__account__sidebar li").click(function(e){
    e.preventDefault();
    $(".account__details").hide();
    var attr = $(this).attr("account-attr");
    // alert (attr);
    var class_attr = '.cstm_'+ attr;
    console.log(class_attr);
    $(class_attr).show();
    localStorage.setItem("active_dashboard",class_attr);
    $(".cstm__account__sidebar li").removeClass('active');
    $(this).addClass('active');
    });

var loadedAnimation = localStorage.getItem("animationLoaded");
  if(localStorage.getItem("animationLoaded") === null){
    $('body').addClass('animation__loading');
  }
  else{
     $('body').removeClass('animation__loading');
  }
  // $(".accordion").click(function(){
  //    _this = $(this).find(".accordion__body");
  //    $('.accordion__body').not(_this).hide();
  //    $(this).find(".accordion__body").toggle();
  //    $('.accordion').not(this).addClass('accordion-span');
  //    $(this).toggleClass('accordion-span');
  //  });
  
  
});



